import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      greeting: "Hello!",
      button: "Switch to Korean",
    },
  },
  ko: {
    translation: {
      greeting: "안녕하세요!",
      button: "한국어로 변경",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ko', // 초기 언어
  fallbackLng: 'en', // 기본 언어
  interpolation: {
    escapeValue: false, // React는 자동으로 XSS 보호
  },
});

export default i18n;